<script setup lang="ts">
import { computed } from 'vue';
import { resolveName } from '@precon-tools-suite-by-shared/shared-names-ui';
import { useRiskBadgeColors } from '../composables/riskBadgeColors';
import Badge from 'primevue/badge';

export type RiskValueBadgeInput = {
    name: string | null | undefined;
    value: number | null | undefined;
    color: string | null | undefined;
};

const props = withDefaults(
    defineProps<{
        input?: RiskValueBadgeInput;
        loading?: boolean;
    }>(),
    {
        input: undefined,
        loading: false,
    }
);

const color = computed(() => props.input?.color);

const { darkStyle, lightStyle } = useRiskBadgeColors(color);
</script>
<template>
    <Skeleton v-if="loading" style="width: 4rem; height: 2rem" />
    <span v-else class="flex flex-nowrap joined-badges-host">
        <Badge
            :value="input?.value ?? 'X'"
            :style="darkStyle"
            class="left-badge"
        />
        <Badge
            :value="input?.name ?? resolveName()"
            :style="lightStyle"
            class="right-badge"
        />
    </span>
</template>
